/**
 * @file Form 表单
 */
import Form from 'antd/es/form';
export { Form };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvRm9ybS9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFFSCxPQUFPLElBQWtDLE1BQU0sY0FBYyxDQUFBO0FBRTdELE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQSJ9